function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "_25",
  x: 189.5,
  y: 43.274,
  width: 82,
  height: 86,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "OVER",
  x: 0,
  y: 55.274,
  width: 128,
  height: 71,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur-2"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur-2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "YEARS_",
  x: 333.5,
  y: 55.274,
  width: 148,
  height: 71,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur-3"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur-3"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2",
  "data-name": "Group 2",
  transform: "translate(-729.5 -3825.726)"
}, /*#__PURE__*/React.createElement("g", {
  id: "award-new",
  transform: "translate(856.458 3822.444)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  d: "M182.571,63.6c-.988-2.938-1.048-6.551-1.112-10.373-.1-5.934-.2-12.072-3.848-16.919-3.683-4.9-9.72-6.885-15.559-8.808-3.714-1.226-7.221-2.382-9.756-4.166-2.487-1.75-4.676-4.591-7-7.6-3.709-4.813-7.545-9.792-13.587-11.687-5.791-1.817-11.8-.035-17.609,1.694-3.838,1.14-7.467,2.218-10.763,2.218S96.419,6.878,92.581,5.74C86.766,4.012,80.76,2.227,74.97,4.046c-6.042,1.9-9.88,6.876-13.589,11.691-2.318,3.008-4.507,5.849-6.992,7.6-2.535,1.784-6.044,2.941-9.756,4.164C38.8,29.421,32.76,31.413,29.075,36.306c-3.647,4.847-3.75,10.983-3.85,16.919C25.16,57.048,25.1,60.66,24.112,63.6c-.924,2.749-3.01,5.6-5.22,8.61-3.444,4.7-7.35,10.025-7.35,16.282s3.905,11.585,7.35,16.285c2.21,3.015,4.3,5.861,5.22,8.61.988,2.938,1.048,6.551,1.112,10.373.1,5.934.2,12.072,3.848,16.919,3.055,4.058,7.727,6.115,12.56,7.8L19.424,197.137l31.793-2.747,19.323,24.567,21.65-47.6c.129-.039.26-.076.391-.115,3.838-1.14,7.467-2.216,10.763-2.216s6.925,1.078,10.763,2.216c.313.092.628.182.943.275L135.8,218.835l19.659-24.315,31.75,3.158-21.712-49.359c4.676-1.655,9.159-3.707,12.121-7.643,3.645-4.845,3.748-10.983,3.848-16.917.062-3.822.124-7.433,1.112-10.376.924-2.749,3.01-5.6,5.22-8.612,3.444-4.7,7.35-10.027,7.35-16.285S191.238,76.9,187.794,72.2C185.583,69.194,183.495,66.348,182.571,63.6ZM68.878,205.408,54.52,187.152l-23.643,2.043L48.4,150.788a25.8,25.8,0,0,1,5.984,2.865c2.485,1.75,4.674,4.589,6.992,7.6,3.712,4.813,7.548,9.794,13.589,11.689a19.215,19.215,0,0,0,8.443.519Zm106.986-15.818-23.615-2.35-14.611,18.069-13.94-31.8a23.512,23.512,0,0,0,2.81.192,17.26,17.26,0,0,0,5.208-.762c6.042-1.9,9.877-6.874,13.587-11.687,2.32-3.008,4.509-5.849,6.994-7.6a26.98,26.98,0,0,1,6.428-3.028Zm6.087-88.819c-2.423,3.305-4.929,6.724-6.19,10.479-1.32,3.929-1.392,8.236-1.461,12.4-.086,5.08-.165,9.879-2.478,12.954-2.351,3.125-7.077,4.681-12.081,6.331-4.053,1.336-8.247,2.719-11.658,5.12-3.363,2.368-5.987,5.771-8.522,9.06-3.179,4.125-6.185,8.023-10.056,9.238-3.643,1.14-8.331-.254-13.3-1.727-4.177-1.24-8.493-2.523-12.866-2.523s-8.689,1.283-12.864,2.523c-4.967,1.475-9.66,2.871-13.3,1.727-3.874-1.216-6.879-5.115-10.061-9.242-2.535-3.289-5.156-6.689-8.519-9.058-3.413-2.4-7.605-3.783-11.658-5.12-5-1.648-9.729-3.208-12.081-6.331-2.313-3.075-2.392-7.873-2.478-12.954-.069-4.164-.141-8.471-1.461-12.4-1.26-3.753-3.767-7.172-6.187-10.477-3.1-4.231-6.032-8.227-6.032-12.28s2.929-8.047,6.03-12.278c2.423-3.305,4.927-6.722,6.19-10.477,1.318-3.929,1.392-8.233,1.461-12.4.086-5.083.165-9.882,2.48-12.956,2.351-3.123,7.075-4.681,12.078-6.329C51,32.717,55.191,31.334,58.6,28.931c3.361-2.366,5.982-5.768,8.519-9.058,3.182-4.127,6.185-8.026,10.059-9.242a10.008,10.008,0,0,1,3-.42c3.067,0,6.607,1.05,10.3,2.147,4.172,1.24,8.488,2.523,12.861,2.523s8.691-1.283,12.866-2.523c4.967-1.477,9.66-2.869,13.3-1.727,3.874,1.214,6.877,5.113,10.056,9.238,2.537,3.289,5.158,6.692,8.524,9.06,3.411,2.4,7.6,3.783,11.658,5.12,5,1.648,9.727,3.206,12.078,6.331,2.315,3.075,2.394,7.873,2.48,12.954.069,4.164.141,8.471,1.461,12.4,1.26,3.756,3.767,7.172,6.19,10.479,3.1,4.231,6.03,8.227,6.03,12.278S185.051,96.54,181.95,100.771Z",
  transform: "translate(0 0)",
  fill: "#000000"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_4",
  "data-name": "Ellipse 4",
  transform: "translate(909 3860)",
  fill: "#0fa626 ",
  stroke: "#000000",
  strokeWidth: 6
}, /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 51,
  r: 51,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 51,
  r: 47.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 729.5, 3825.73)",
  filter: "url(#_25)"
}, /*#__PURE__*/React.createElement("text", {
  id: "_25-2",
  "data-name": 25,
  transform: "translate(198.5 49.27)",
  fill: "#ffffff",
  fontSize: 50,
  fontFamily: "SegoeUI-Semibold, Segoe UI",
  fontWeight: 600
}, /*#__PURE__*/React.createElement("tspan", {
  x: 4.241,
  y: 54
}, "25"))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 729.5, 3825.73)",
  filter: "url(#OVER)"
}, /*#__PURE__*/React.createElement("text", {
  id: "OVER-2",
  "data-name": "OVER",
  transform: "translate(9 61.27)",
  fill: "#000000",
  fontSize: 40,
  fontFamily: "Roboto, sans-serif",
  fontWeight: 500
}, /*#__PURE__*/React.createElement("tspan", {
  x: 4.248,
  y: 43
}, "OVER"))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 729.5, 3825.73)",
  filter: "url(#YEARS_)"
}, /*#__PURE__*/React.createElement("text", {
  id: "YEARS_2",
  "data-name": "YEARS ",
  transform: "translate(342.5 61.27)",
  fill: "#000000",
  fontSize: 40,
  fontFamily: "Roboto, sans-serif",
  fontWeight: 500
}, /*#__PURE__*/React.createElement("tspan", {
  x: 6.152,
  y: 43
}, "YEARS "))));

var SvgExperience = function SvgExperience(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 481.5,
    height: 215.675,
    viewBox: "0 0 481.5 215.675",
    className: "experience-svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExperience, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/experience.6aa32d44.svg";
export { ForwardRef as ReactComponent };